import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ApplicationService } from "../../application/services/application.service";
import { IStemexeModule } from "../../../../data-providers/interfaces/interfaces";
import { StemexeDataProviderService } from "../../../../data-providers/services/stemexe-data-provider.service";
import { AuthService, AuthType } from "../../../../shared/services/auth.service";
import { DataProvider, PagedData, PagedDataItem } from "../../../../data-providers/models/models";
import { ApplicationStatusPost } from "src/app/activities/shared/enums/application-status-enum-activity";
import { NameId } from "src/app/activities/shared/models/UserResult-activity";

@Injectable({
  providedIn: "root"
})
export class EspDataProviderService implements IStemexeModule {
  type: AuthType = AuthType.ESP;
  constructor(
    private _applicationService: ApplicationService,
    private _authService: AuthService) {
  }

  initialize(): void {
  }

  getDataProviders(providerType: string): Observable<DataProvider[]> {
    let espDataProviders: DataProvider[] = [];
    if (providerType == 'ActivitySource') {
      return this._authService.getAuthAddonByType(AuthType.ESP).pipe(
        switchMap(addon => {
          let reqDataProvider: DataProvider = new DataProvider();
          reqDataProvider.title = 'Requests';
          reqDataProvider.id = '1';
          // reqDataProvider.system = addon.Configuration.domain;
          reqDataProvider.system = addon?.BaseUrl
          reqDataProvider.tenantId = addon?.OrganziationId;
          reqDataProvider.getData = (params) => {
            return  this._applicationService.getDefinitionsForFilter(
              params.pageNo,
              params.searchText,
              params.selectedStatuses,
              params.recordPerPage,
              params.sortBy,
              params.isMySpace,
              params.myApplications,
              params.applicantId,
              params.parentApplicationId,
              params.definitionIds,
              params.applicationListType,
              params.isRecord,
              params.survey,
              params.isAll,
              params.forActivities ).pipe(
              map((resp) => {
                let pagedData = new PagedData();
                pagedData.items = resp.map(app => {
                  let pageItem: PagedDataItem = {
                    id: app.id.toString(),
                    title: `${app.name}`,
                    extraData: app,
                    url: '',
                    // getData: (fn => null),
                    getData : (nextPageToken) => this._getNextData(reqDataProvider, app, nextPageToken)
                  };
                  return pageItem;
                })
                return pagedData;
              }
              
              ));
        
  
            // return this._applicationService.getOpenRequestsForMimRequest(params.pageNo, params.noOfRecords, params.search).pipe(
            //   map(resp => {
            //     let pagedData = new PagedData();
            //     pagedData.items = resp.applications.map(app => {
            //       let pageItem: PagedDataItem = {
            //         id: app.id.toString(),
            //         title: `${app.definitionName} ${app.applicationNumber}`,
            //         extraData: app,
            //         url: '',
            //         getData: (fn => null)
            //       };
            //       return pageItem;
            //     })
            //     return pagedData;
            //   })
            // )
            //return this._getProviderData(reqDataProvider, token)
          }
          espDataProviders.push(reqDataProvider);
          return of(espDataProviders);
        })
      );
    }
  }
  private _getProviderData(provider: DataProvider, nextPageToken?: any): Observable<PagedData> {
    console.log('token', nextPageToken)
    let pagedData = new PagedData();
    let item1 = new PagedDataItem();
    item1.id = '1';
    item1.extraData = {
      'createdBy': 9,
      'createdAt': '10-10-2022'
    }
    item1.title = 'Job Application',
      item1.url = '/pages/requests/1'
    pagedData.items = [item1];


    pagedData.items.map(item => {
      item.getData = (nextPageToken) => this._getNextData(provider, item, nextPageToken);
      return item;
    })
    return of(pagedData);
  }


  private _getNextData(provider: DataProvider, pagedDataItem: PagedDataItem, nextPageToken?: any) {
    // console.log('pagedDataItem :>> ', pagedDataItem);
    // console.log('provider :>> ', provider);
    // let pagedData = new PagedData();
    // let pageNo: number = 0;
    // let searchText: string = "";
    // let applicationStatuses: ApplicationStatusPost[] = [3, 4, 5];
    // let recordPerPage: number = 1000000;
    // let sortBy: number = 1;
    // let isMySpace: boolean;
    // let myApplications: boolean;
    // let applicantId: number = null;
    // let parentApplicationId: number = null;

    // let definitionIds: number[] = nextPageToken.definitionIds;
    // let applicationListType = 1;
    // let defFieldsSearchValues: NameId[] = []
  return  this._applicationService.getApplicationsWithPagingV2(
    nextPageToken.pageNo,
    nextPageToken.searchText,
    nextPageToken.applicationStatuses,
    nextPageToken.recordPerPage,
    nextPageToken.sortBy,
    nextPageToken.isMySpace,
    nextPageToken.myApplications,
    nextPageToken.applicantId,
    nextPageToken.parentApplicationId,
    nextPageToken.definitionIds,
    nextPageToken.applicationListType,
    nextPageToken.defFieldsSearchValues
    ).pipe(
        map(resp => {
          let pagedData = new PagedData();
          pagedData.items = resp.applications.map(app => {
            let pageItem: PagedDataItem = {
              id: app.id.toString(),
              title: `${app.applicationName} ${app.applicationNumber}`,
              extraData: app,
              url: '',
              getData: (fn => null)
            };
            return pageItem;
          })
          return pagedData;
        })
      )}


    // return of(pagedData);


  


  openUrl(url: string, context: any): any { }
}
